import client from './contentful';

export const fetchReferrals = async () => {
  try {
    const entries = await client.getEntries({ content_type: 'referrals', limit: 1 });
    return entries.items[0];
  } catch (error) {
    console.error('Contentful fetch error:', error);
    return null;
  }
};